import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-history-tile',
    standalone: true,
    imports: [],
    templateUrl: './history-tile.component.html',
    styleUrl: './history-tile.component.scss'
})
export class HistoryTileComponent {
    @Input() eventName!: string;
    @Input() eventPlace!: string;
    @Input() dueDate!: string;
    @Input() feedback!: string;
    @Input() assignedTo!: string;
    @Input() eventStatus!: string;
}
